export class UserCardioWorkout {
  public user_cardio_workout_id?: number;
  public user_id?: number;
  public workout_date?: string;
  public level?: number;
  public exercise_id?: number;
  public exercise_other?: string;
  public minutes?: number;
  public seconds?: number;
  public intensity?: number;
  public difficulty?: number;
  public created?: string;
  public modified?: string;

  constructor(
    user_cardio_workout_id?: number,
    user_id?: number,
    workout_date?: string,
    level?: number,
    exercise_id?: number,
    exercise_other?: string,
    minutes?: number,
    seconds?: number,
    intensity?: number,
    difficulty?: number,
    created?: string,
    modified?: string
  ) {
    this.user_cardio_workout_id = user_cardio_workout_id;
    this.user_id = user_id;
    this.workout_date = workout_date;
    this.level = level;
    this.exercise_id = exercise_id;
    this.exercise_other = exercise_other;
    this.minutes = minutes;
    this.seconds = seconds;
    this.intensity = intensity;
    this.difficulty = difficulty;
    this.created = created;
    this.modified = modified;
  }
}
